import { DeviceTypeHelper, IDeviceType } from '@ncss/models/dist/v3';
import { EndDeviceMessage } from '../messages/endDeviceMessage';
import { shallowRef, ShallowRef } from 'vue';
import { EndDeviceRssiToColor, EndDeviceRssiToImgUrl, EndDeviceRssiToString } from '../../base/utils';
import { DeviceTypeToImgUrl } from '@/utils/device.utils';

export abstract class DirectConnectEndDevice {
  deviceId: number;
  deviceType?: IDeviceType;
  deviceTypeImgUrl?: string;

  get lastMsgAt() {
    return this._lastMsgAt.value;
  }

  get signalStrengthImg() {
    return EndDeviceRssiToImgUrl(this._firstHopRssi.value);
  }

  get signalStrengthColor() {
    return EndDeviceRssiToColor(this._firstHopRssi.value);
  }

  get signalStrengthStr() {
    return EndDeviceRssiToString(this._firstHopRssi.value);
  }

  protected _useMetric: boolean;
  protected _firstHopRssi: ShallowRef<number>;
  protected _lastMsgAt: ShallowRef<Date>;

  constructor(msg: EndDeviceMessage, useMetric: boolean) {
    this._useMetric = useMetric;
    this.deviceId = msg.srcAddr;
    this.deviceType = DeviceTypeHelper.GetDeviceTypeBySerialNumber(msg.srcAddr) || undefined;
    this.deviceTypeImgUrl = this.deviceType ? DeviceTypeToImgUrl(this.deviceType) : undefined;
    this._firstHopRssi = shallowRef(msg.firstHopRssi);
    this._lastMsgAt = shallowRef(new Date());
  }

  abstract updateFromEndDeviceMessage(msg: EndDeviceMessage): void;
}
